import React from 'react';
import { FileDown, FileCheck2 } from 'lucide-react';
import { Button } from '../ui/button';
import { downloadPdf } from '../../lib/download';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Boutons d'export PDF d'un QCM : sujet (à remplir) et corrigé
export const QcmPdfButtons = ({ qcm, size = 'sm', className = '' }) => {
  const dl = (corrige) => downloadPdf(`${API_URL}/qcms/${qcm.id}/export-pdf`, `qcm_${(qcm.titre || 'qcm').replace(/[^\w]+/g, '_')}${corrige ? '_corrige' : ''}.pdf`, corrige ? { corrige: true } : {});
  return (
    <>
      <Button type="button" variant="outline" size={size} className={`gap-1 ${className}`} onClick={(e) => { e.stopPropagation(); dl(false); }} title="Télécharger le QCM à imprimer (sans les réponses)" data-testid={`qcm-pdf-sujet-${qcm.id}`}>
        <FileDown className="w-3.5 h-3.5" /> PDF sujet
      </Button>
      <Button type="button" variant="outline" size={size} className={`gap-1 text-emerald-700 border-emerald-200 hover:bg-emerald-50 ${className}`} onClick={(e) => { e.stopPropagation(); dl(true); }} title="Télécharger le corrigé (réponses et explications)" data-testid={`qcm-pdf-corrige-${qcm.id}`}>
        <FileCheck2 className="w-3.5 h-3.5" /> Corrigé
      </Button>
    </>
  );
};
